import { TransactionType, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { ForkLiftItems } from "../fork-lift-items/fork-lift-items.entity";
import { StockIn } from "../stock-in/stock-in.entity";
import { ForkJobPurpose } from "./dto/fork-job-purpose.enum";
import { ForkLiftJobStatus } from "./dto/fork-lift-job-status.enum";

@Entity('fork_lift_jobs')
export class ForkLiftJobs {

  @PrimaryGeneratedColumn("increment",{name:'job_id'})
  jobId:number;
  @Column("varchar",{
    nullable:false,
    length:50,
    name:"job_code"
    })
    jobCode:string;
  @Column("datetime", {
        nullable: true,
        name: "date"
    })
    transactionTime: Date;
    @Column({
        type: 'enum',
        enum: ForkLiftJobStatus,
        nullable: false,
        name: 'status',
        default:"Open",
    })
    status: ForkLiftJobStatus;
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: false,
        name: 'job_purpose',
        default:"palleting",
    })
    transactionType: TransactionType;
    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: false,
        name: 'transfer_status',
        default:TransferStatusEnum.IN_TRANSIT,
    })
    transferStatus: TransferStatusEnum;
    @Column("int", {
      nullable: false,
      default:0,
      name: "total_job_cartons",
      })
      totalJobCartons: number;
      @Column("int", {
        nullable: false,
        name: "shortage_cartons",
        default:0,
        })
        shortageCartons: number;
        @Column("int", {
          nullable: false,
          default:0,
          name: "damaged_cartons",
          })
          damagedCartons: number;
    @Column("int", {
      nullable: false,
      name: "unit_id",
      })
      plantId: number;
      @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        name: "tot_issued_quantity"
      })
      totalIssuedQuantity: number;
      @Column({
        type: 'decimal', precision: 10, scale: 3,
        nullable: false,
        default:0,
        name: "tot_received_quantity",
        })
      totalReceivedQuantity: number;
      @Column({
        type: 'decimal', precision: 10, scale: 3,
          nullable: false,
          default:0,
          name: "excess_quantity",
          })
      excessQuantity: number;
      @Column({
        type: 'decimal', precision: 10, scale: 3,
          nullable: false,
          default:0,
          name: "damaged_quantity",
          })
        damagedQuantity: number;
      @Column("varchar",{
        nullable:true,
        length:100,
        name:"message"
        })
        message:string;
        @Column("int", {
          nullable: true,
          name: "reported_id",
          })
          reportedId: number;
          @Column("int", {
            nullable: true,
            name: "from_plant_id",
            })
            fromPlantId: number;
          @Column("int", {
            nullable: true,
            name: "to_plant_id",
            })
            toPlantId: number;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      default: "Admin",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @Column("decimal", {
    nullable: false,
    default:0,
    precision:10,scale:3,
    name: "total_job_loose_pouches",
    })
    totalJobLoosePouches: number;

    @Column('boolean',{
      name:'montly_mis_flag',
      default:false,
    })
    montlyMisFlag : boolean

    @Column('boolean',{
      name:'daywise_shrimp_flag',
      default:false
    })
    daywiseShrimpFlag : boolean

  @OneToMany(type => ForkLiftItems, forkLiftItems => forkLiftItems.forkLiftJobInfo, { cascade: true })
  forkLiftItemsInfo: ForkLiftItems[];

  @ManyToOne(type => StockIn, StockIn => StockIn.reportingLogId, { nullable: false, })
  @JoinColumn({ name: "reported_id" })
  reportingInfo: StockIn;
}
